document.addEventListener('DOMContentLoaded', function () {
	const popup = document.getElementById('pophihide1');
	const popupOverlay = document.getElementsByClassName('stanza-overlay-backgound');

	function getsubCookie(cname) {
		const name = cname + '='; //eslint-disable-line
		const decodedCookie = decodeURIComponent(document.cookie);
		const ca = decodedCookie.split(';');
		for (let i = 0; i < ca.length; i++) { //eslint-disable-line
			let c = ca[i];
			while (c.charAt(0) === ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) === 0) {
				return c.substring(name.length, c.length);
			}
		}
		return '';
	}
	const servicebtn = document.getElementById('survieenowbutton');
	if (servicebtn) {
		servicebtn.onclick = function () {
			document.getElementById('pophihide').style.display = 'none';
			document.getElementById('pophihide1').style.display = 'none';
		};
	}
	const cookiesbCheck = getsubCookie('newsletter_subs_popup_set');
	if (cookiesbCheck === '') {
		if (popupOverlay[0]) popupOverlay[0].style.display = 'block';

		if (popup) popup.style.display = 'flex';
	}
});
